export default __webpack_public_path__ + "locales/si/PDFFormDialog.json?hash=191f7dae08434b4acc6abf0e259b62f2";